  <div class="d-flex justify-content-center  px-4  "  >
<!--    [class.closed]="cmpData.open !== true"-->
    <div class="position-relative view-circle "  >
      <div class="circle-grain d-flex justify-content-center pointer"   [style.backgroundImage]="'url(' + cmpData?.thumbnail+ ')'" (click)="openPlayerWindow(cmpData)">
        <div  class="info-pourcentage mt-auto">
          <div class="d-flex justify-content-between">
            <span class="info-grain" >{{"catalogue.score" | translate}} </span>
            <span class="info-grain">
                {{ cmpData?.scorable === 0 ? '--' : (cmpData?.score !== undefined ? cmpData?.score + '%' : '') }}
              <!-- <ng-container *ngIf="data?.scorable !== 1; else notScoreAble">
                --
              </ng-container>
              <ng-template #notScoreAble>
                {{ data?.score }} %
              </ng-template> -->
              </span>
          </div>
<!--          <div class="d-flex justify-content-between">-->
<!--            <span class="info-grain" >{{'catalogue.progress'| translate}} </span>-->
<!--            <span class="info-grain">{{ cmpData?.progression }} %</span>-->
<!--          </div>-->
<!--          <div class="d-flex justify-content-between">-->
<!--            <span class="info-grain" >{{'catalogue.like'| translate}} </span>-->
<!--            <span class="info-grain">{{ cmpData?.likes_count  }} </span>-->
<!--          </div>-->
        </div>
      </div>
<!--<ng-container *ngIf="newCmpData$ |async  as data">-->

      <svg viewBox="0 0 36 36" class="circular-chart position-absolute">

        <path class="circle" style="stroke-width: 2.2px; stroke: #ffffff; background-color: transparent;"
              stroke-dasharray="100 , 100'"
              d="M18,33.9C9.2,33.9,2.1,26.8,2.1,18S9.2,2.1,18,2.1l0,0c8.8,0,15.9,7.1,15.9,15.9C33.9,26.8,26.8,33.9,18,33.9" />
        <path class="circle matching" [attr.stroke-dasharray]="cmpData.progression  + ', 100'"
              d="M18,33.9C9.2,33.9,2.1,26.8,2.1,18S9.2,2.1,18,2.1l0,0c8.8,0,15.9,7.1,15.9,15.9C33.9,26.8,26.8,33.9,18,33.9" />
        <!-- <text class="text" x="50%" y="50%" text-anchor="middle" stroke="#000000" stroke-width="0px" dy=".3em">test m</text> -->
      </svg>
<!--</ng-container>-->
      <!--span class="info-grain">Temps: {{ ressource?.temps }}</span-->
      <ng-container *ngIf="cmpData?.resourceType === 'link' || cmpData.metas?.resourceType === 'download'; else elseTemplate">
        <a href="{{cmpData?.url}}" target="_blank"><p class="mt-5 text-center cursor-pointer fs-9" style="margin-top: 9px !important;">{{cmpData?.titre}}</p></a>
      </ng-container>
      <ng-template #elseTemplate>
        <p  class="mt-5 text-center cursor-pointer fs-9" style="margin-top: 9px !important;" (click)="openPlayerWindow(cmpData) ">{{cmpData?.titre}}</p>
<!--        <p *ngIf="cmpData._type ==='screen'" class="mt-5 text-center cursor-pointer fs-9" style="margin-top: 9px !important;" (click)="openPlayer(cmpData)">{{cmpData?.titre}}</p>-->
        <div class="mb-5 text-end text-black-50" *ngIf="cmpData?.status === 'draft'">
          <i class="fa-solid fa-circle-exclamation"></i>
          {{'grain.draft' | translate}}
        </div>
      </ng-template>

      <!-- <h6 class="mt-5 text-center cursor-pointer" (click)="openPlayerWindow(cmpData?.id)"> {{ cmpData?.metas?.title }} </h6> -->
    </div>
  </div>

<ng-template #loadingTemplate>
  <ngx-shimmer-loading [shape]="'circle'" [width]="'100%'"></ngx-shimmer-loading>
</ng-template>
